import React, {useEffect} from 'react';
import styled from "styled-components";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {useDispatch, useSelector} from "react-redux";
import {HelmetProvider, Helmet} from 'react-helmet-async'
import InnerBanner from "../../components/InnerBanner";
import EquipmentList from "../../components/Equipment/EquipmentList";
import {fetchEquipment} from "../../api/redux/equipment";
import gsap, {CSSPlugin} from "gsap";
import {SplitText} from "gsap/SplitText";

const MyComponent = () => {

    const dispatch = useDispatch()

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.EQUIPMENTS
        dispatch(fetchEquipment([api_url]))
    }, [])

    let getPost = useSelector(state => state.equipment)

    let meta=getPost?.posts?.page_data?.meta;
    let banner=getPost?.posts?.page_data?.banner;
    let equipments=getPost?.posts?.equipments;


    return (
        <HelmetProvider>
            {/*dynamic title */}
            <Helmet>
                <title>{`${meta?.meta_title ? meta?.meta_title : 'Equipments | UCC Infrastructure Ltd.'}`}</title>
                <meta name="description"  content={meta?.meta_desc ? meta?.meta_desc :''}/>
                <meta property="og:title" content={`${meta?.og_title ? meta?.og_title : 'Equipments | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:subtitle" content={`${meta?.og_title ? meta?.og_title : 'Equipments | UCC Infrastructure Ltd.'}`}/>
                <meta property="og:description" content={meta?.og_desc ? meta?.og_desc :''}/>
                <meta property="og:url" content={window?.location?.href}/>
                <meta property="og:image" content={banner?.image}/>
                <meta property="og:type" content={"website"}/>
            </Helmet>

            <StyledComponent>
                <InnerBanner img={banner?.image} mimg={banner?.mobile_image} title={banner?.subtitle} text={banner?.title}/>
                <EquipmentList data={equipments}/>

            </StyledComponent>
        </HelmetProvider>

    );
};

const StyledComponent = styled.section`

`;

export default MyComponent;
